export const ALLOWED_TYPES = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/tiff",
];

export const JOB_TYPE = {
    PARSE: "parse",
    SPLIT: "split",
    TRANSCRIBE: "transcribe",
};

export const RUN_BUTTON_LABEL = {
    IDLE: "Run",
    PROCESSING: "Processing...",
};

export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 28;
export const DEFAULT_FONT_SIZE = 16;